import Image from "next/image"
import GradientContainer from "../gradient/gradient-container"

const Hero = () => {
  return (
    <div>
      <div className="bg-background-primary-dark-dark py-10 xl:py-20 flex flex-col items-center"
         style={{
          backgroundImage:'url(/images/platform/hero-bg-v2.svg)',
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
      }}
      >
        <div className="space-y-2 text-center">
          <h4 className="mobile-h4 sm:h5 md:h4 xl:h3 text-white">
            One <span className="text-[#4ADE80]">powerful</span> platform
          </h4>
          <h4 className="mobile-h4 sm:h5 md:h4 xl:h3 text-white">
            Three <span className="text-[#4ADE80]">distinct</span> functions
          </h4>
        </div>
        <GradientContainer overrideClassName="w-[150px] h-[8px] my-10 xl:mt-6" />
        <div className="lg:flex items-center lg:space-x-20">
          <div className="space-y-4 text-center lg:text-right">
            <h4 className="subheading-xl-2 sm:subheading-xxl-2 md:subheading-xxxl-2 xl:subheading-xxxxl-2
            text-white">
              Technology
            </h4>
            <h4 className="subheading-xl-3 sm:subheading-xxl-3 md:subheading-xxxl-3 xl:subheading-xxxxl-3
            text-[#4ADE80]">
              Procurement
            </h4>
            <h4 className="subheading-xl-4 sm:subheading-xxl-4 md:subheading-xxxl-4 xl:subheading-xxxxl-4 italic
            text-[#22D3EE]">
              Support
            </h4>
          </div>
          <div className="relative w-[312px] h-[268px] sm:w-[439px] sm:h-[376px] xl:h-[336px] 
          xl-2:w-[579px] xl-2:h-[349px]">
            <Image src="/images/platform/hero.png" alt="hero" layout='fill' objectFit="contain" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
